
// PagebyPage: Duplicate announcement text for seamless marquee scroll
document.addEventListener('DOMContentLoaded', function() {
  var slides = document.querySelector('.announcement-bar__slides');
  if (slides && slides.children.length > 0) {
    var original = slides.innerHTML;
    slides.innerHTML = original + original;
  }
});
